import { SectionHeader } from '~analytics-components/section-header';
import type { ResolvedPageFilter } from '~containers/analytics/overview-page/use-page-filter';
import { KpiCardFromSpec } from '../kpis/kpi-card-from-spec';
import type { KpiCardSpec } from '../kpis/card-spec';
import { RETENTION_BREAKDOWN_CARDS, BOTTOM_ROW_CARDS } from './cards';
import style from './style.module.scss';

export const RetentionSection = ({
    filter,
}: {
    filter: ResolvedPageFilter;
}) => {
    const renderCard = (spec: KpiCardSpec, index: number) => (
        <KpiCardFromSpec
            key={`${spec.source}-${spec.form}-${index}`}
            spec={spec}
            pageRange={filter.range}
            pageRegion={filter.provinces}
            compareEnabled={filter.compare}
            waveKey={filter.waveKey}
        />
    );

    return (
        <div className={style.dashboard}>
            <section className={style.section}>
                <SectionHeader title="Retention breakdown" />
                <div className={style.dashboard_grid}>
                    {RETENTION_BREAKDOWN_CARDS.map(renderCard)}
                </div>
            </section>
            {/* No SectionHeader: two independent cards, not a group to
                head. Each owns its own title + subtitle (cards.ts). */}
            <section className={style.section}>
                <div className={style.dashboard_grid}>
                    {BOTTOM_ROW_CARDS.map(renderCard)}
                </div>
            </section>
        </div>
    );
};
